import fetch from '@/common/js/http';

const report = {
    namespaced: true,
    state: {},
    mutations: {},
    actions:{
        // 获取部门绩效
        getDeptAchievements({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    url:"performance/dept",
                    methods:"get",
                    params:params
                }).then(response=>{
                    resolve(response)
                },error=>{
                    reject(error)
                })
            })
        },
        // 获取报表-项目执行情况列表
        getContractList({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    methods:"get",
                    url:"contract/page",
                    params:params
                }).then(response=>{
                    resolve(response)
                },error=>{
                    reject(error)
                })
            })
        },

        // 报表-获取人员填写情况
        getUserUtilization({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    methods:"get",
                    url:"performance/utilization",
                    params:params
                }).then(success=>{
                    resolve(success)
                },error=>{
                    reject(error)
                })
            })
        }
    }
}

export default report;


// WEBPACK FOOTER //
// ./src/vuex/modules/report.js